import React from 'react';
import { Box } from '@mui/material';
import EmployeeDetailDashboard from '../../components/admin/EmployeeDetailDashboard';

const EmpleadoDetallePage = () => { 

  return (
    <Box sx={{ p: 2 }}>
      <EmployeeDetailDashboard
        //windows={employees}
        onReorder={(newOrder) => {
          console.log('Nuevo orden de empleados:', newOrder);
        }}
      />
    </Box>
  );
};

export default EmpleadoDetallePage;